import en from "../en.json" with { type: "json" };

/** Every phrase key known to the build. A key that is not in en.json does not compile. */
export type PhraseKey = keyof typeof en;

export const LAUNCH_LOCALES = ["en", "af", "zu", "st"] as const;
export type Locale = (typeof LAUNCH_LOCALES)[number] | (string & {});

const KEY_FORMAT = /^[a-z0-9_]+(\.[a-z0-9_]+){2,}$/;

export function isValidKey(key: string): boolean {
  return KEY_FORMAT.test(key);
}

export function englishText(key: PhraseKey): string {
  return en[key].text;
}

/**
 * Builds a translator for one locale. `approved` holds only approved text for that locale,
 * loaded from the published_translation view. Any key without approved text falls back to the
 * English master (TRN-03), so a page always reads correctly.
 */
export function createTranslator(approved: ReadonlyMap<string, string> = new Map()) {
  return function t(key: PhraseKey): string {
    return approved.get(key) ?? en[key].text;
  };
}

export const tEnglish = createTranslator();

/** All keys and limits, for the migration job and the key check. */
export const phrases: Readonly<Record<PhraseKey, { text: string; max: number }>> = en;
